/**
 * Format a number as Indian Rupee currency.
 * Example: 5000000 → "₹50,00,000"
 */
export function formatIndianCurrency(amount: number): string {
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(amount);
}

/**
 * Format a number as compact Indian notation.
 * Example: 10400 → "10.4K", 1500000 → "15L", 50000000 → "5 Cr"
 */
export function formatCompactIndian(amount: number): string {
  if (amount >= 10000000) {
    return `${(amount / 10000000).toFixed(1)} Cr`;
  }
  if (amount >= 100000) {
    return `${(amount / 100000).toFixed(1)}L`;
  }
  if (amount >= 1000) {
    return `${(amount / 1000).toFixed(1)}K`;
  }
  return amount.toString();
}

/**
 * Format land area — adds "Acres" suffix.
 */
export function formatAcres(acres: number): string {
  if (acres >= 100) {
    return `${acres} Acres`;
  }
  return `${acres.toFixed(1)} Acres`;
}

/**
 * Truncate text to specified length with ellipsis.
 */
export function truncate(text: string, maxLength: number = 120): string {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength).trimEnd()}...`;
}

/**
 * Build a wa.me deep-link from a phone number string.
 * Example: "+91 90350 63455" → "https://wa.me/919035063455"
 */
export function buildWhatsAppLink(phone: string): string {
  const digits = phone.replace(/\D/g, "");
  return digits ? `https://wa.me/${digits}` : "https://wa.me/";
}

/**
 * Generate a URL-friendly slug from a string.
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-")
    .trim();
}